module.exports = __webpack_public_path__ + "static/7-be539555cbb0ee436b8186035ff0ed84.jpg";